/**
 * @generated SignedSource<<1251ac3b491b215d1c9d2921d9e8994d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceTodoEditMainProductsUnLinkMutation$variables = {
  productId: string;
  todoWorkspaceId: string;
};
export type WorkspaceTodoEditMainProductsUnLinkMutation$data = {
  readonly todoWorkspace: {
    readonly unlinkProduct: {
      readonly id: string;
      readonly linkedProducts: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type WorkspaceTodoEditMainProductsUnLinkMutation = {
  response: WorkspaceTodoEditMainProductsUnLinkMutation$data;
  variables: WorkspaceTodoEditMainProductsUnLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoWorkspaceId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "todoWorkspaceId"
      }
    ],
    "concreteType": "TodoWorkspaceMutation",
    "kind": "LinkedField",
    "name": "todoWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "productId",
            "variableName": "productId"
          }
        ],
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "unlinkProduct",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditMainProductsUnLinkMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoEditMainProductsUnLinkMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f76034e0cf1006bc539062bb39fd2aef",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditMainProductsUnLinkMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditMainProductsUnLinkMutation(\n  $productId: ID!\n  $todoWorkspaceId: ID!\n) {\n  todoWorkspace(id: $todoWorkspaceId) {\n    unlinkProduct(productId: $productId) {\n      id\n      linkedProducts {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f945326669350844801f0670a701299";

export default node;
